'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

interface HeadingProps {
  title: string;
  center?: boolean;
  uppercase?: boolean;
  className?: {
    title?: string;
    subtitle?: string;
    container?: string;
    vector?: string;
  };
  color?: 'white' | 'black' | 'secondary';
  subtitle?: string;
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export function Heading({
  title,
  className,
  tag = 'h2',
  center = false,
  color = 'secondary',
  uppercase = false,
  subtitle,
}: HeadingProps) {
  const Tag = tag;

  return (
    <div
      className={cn(
        'ea-heading__container',
        'flex flex-col items-start justify-start',
        className?.container,
        center && 'items-center justify-center text-center',
        subtitle && 'gap-4 sm:gap-5 lg:gap-6',
      )}
    >
      {!!subtitle && (
        <h3
          className={cn(
            'flex h-[25px] items-center justify-center bg-[#EFF4FF] px-2 text-xs font-bold uppercase text-black sm:h-[28px] sm:text-sm',
            'ea-heading__subtitle',
            'font-heading',
            className?.subtitle,
          )}
        >
          {subtitle}
        </h3>
      )}
      <HtmlRendererRaw
        as={Tag}
        className={cn(
          'relative z-[5] text-left font-bold tracking-tighter text-secondary',
          color === 'secondary' && 'text-secondary',
          color === 'black' && 'text-black',
          color === 'white' && 'text-white',
          center && 'text-center',
          uppercase && 'uppercase',
          tag,
          className?.title,
          'ea-heading__title',
        )}
        html={title}
      />
    </div>
  );
}
